import { Pipe, PipeTransform } from '@angular/core'
import { AuthorizationRuleAPI, getAuthorizationRuleAPIName } from '@mmx/shared'

@Pipe({
  name: 'authorizationRuleAPIName',
  standalone: false,
  pure: true,
})
export class AuthorizationRuleAPINamePipe implements PipeTransform {
  transform(value: AuthorizationRuleAPI): string {
    return getAuthorizationRuleAPIName(value)
  }
}
